<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="help-container">
				<div class="help-header">
					<h1>帮助中心</h1>
					<p>常见问题解答</p>
				</div>
				
				<div class="help-content">
					<div class="help-section">
						<h2>租赁流程</h2>
						<ol class="process-list">
							<li>浏览账号：在平台浏览您需要的游戏账号</li>
							<li>选择账号：点击感兴趣的商品查看详情</li>
							<li>提交订单：选择租赁时长并提交订单</li>
							<li>联系客服：联系客服确认账号信息</li>
							<li>开始游戏：验号无误后即可开始游戏</li>
						</ol>
					</div>
					
					<div class="help-section">
						<h2>常见问题</h2>
						<div class="faq-list">
							<div class="faq-item">
								<h3>Q：账号租金如何计算？</h3>
								<p>租金根据账号的等级、装备、皮肤等因素综合定价，具体价格以商品详情页展示为准。租金按天计算，不足一天按一天计费。</p>
							</div>
							<div class="faq-item">
								<h3>Q：租赁账号需要押金吗？</h3>
								<p>部分高价值账号需要缴纳押金，押金在退租后会全额退还。押金金额会在商品详情页明确标注。</p>
							</div>
							<div class="faq-item">
								<h3>Q：如何联系号主？</h3>
								<p>下单后可在订单详情中获取号主联系方式，或直接联系平台客服协助沟通。</p>
							</div>
							<div class="faq-item">
								<h3>Q：账号出现问题怎么办？</h3>
								<p>如遇到账号异常、被顶号等问题，请第一时间联系客服，我们会及时为您处理。验号后20分钟内发现问题可申请退款。</p>
							</div>
							<div class="faq-item">
								<h3>Q：租赁期间账号被封怎么办？</h3>
								<p>若因租客违规操作导致账号被封（非账号本身问题），责任由租客承担。若因账号本身问题导致封禁，平台会进行相应赔偿。</p>
							</div>
							<div class="faq-item">
								<h3>Q：如何退还账号？</h3>
								<p>租赁到期后，联系客服确认账号状态，验号无误后即可结束租赁。押金会在确认后1-3个工作日内退还。</p>
							</div>
						</div>
					</div>
					
					<div class="help-section">
						<h2>服务须知</h2>
						<ul class="notice-list">
							<li><strong>验号时间</strong>：上号后20分钟内为验号时间，超时视为验号通过</li>
							<li><strong>账号安全</strong>：请勿私自修改账号密码，违规操作将承担相应责任</li>
							<li><strong>装备保护</strong>：租客不得使用账号内非号主赠送的装备和物品</li>
							<li><strong>违规处理</strong>：违规使用账号将扣除全部押金并拉黑处理</li>
							<li><strong>客服时间</strong>：周一至周日 8:00-24:00</li>
						</ul>
					</div>
					
					<div class="help-section">
						<h2>联系我们</h2>
						<p>如有其他问题，欢迎联系在线客服或拨打客服热线。我们的客服人员会为您耐心解答。</p>
						<div class="contact-btn-box">
							<button class="contact-btn" @click="$router.push('/kefu')">联系客服</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	data() {
		return {
		}
	},
	created: function () {
	},
	methods: {
	}
}
</script>

<style scoped>
.help-container {
	max-width: 900px;
	margin: 0 auto;
	padding: 40px 20px;
}

.help-header {
	text-align: center;
	margin-bottom: 50px;
	padding-bottom: 30px;
	border-bottom: 1px solid #eee;
}

.help-header h1 {
	font-size: 36px;
	color: #333;
	margin-bottom: 15px;
	font-weight: bold;
}

.help-header p {
	font-size: 18px;
	color: #666;
}

.help-section {
	margin-bottom: 50px;
}

.help-section h2 {
	font-size: 24px;
	color: #333;
	margin-bottom: 25px;
	padding-left: 15px;
	border-left: 4px solid #409EFF;
	font-weight: bold;
}

.process-list {
	list-style: none;
	padding: 0;
	counter-reset: process-counter;
}

.process-list li {
	font-size: 16px;
	line-height: 2;
	color: #666;
	padding: 12px 0 12px 50px;
	position: relative;
	counter-increment: process-counter;
}

.process-list li::before {
	content: counter(process-counter);
	position: absolute;
	left: 15px;
	top: 50%;
	transform: translateY(-50%);
	width: 28px;
	height: 28px;
	background: #409EFF;
	color: #fff;
	border-radius: 50%;
	text-align: center;
	line-height: 28px;
	font-weight: bold;
	font-size: 14px;
}

.faq-list {
	
}

.faq-item {
	margin-bottom: 25px;
	padding: 20px;
	background: #f9f9f9;
	border-radius: 8px;
}

.faq-item h3 {
	font-size: 16px;
	color: #333;
	margin-bottom: 12px;
	font-weight: bold;
}

.faq-item p {
	font-size: 15px;
	line-height: 1.8;
	color: #666;
	margin: 0;
}

.notice-list {
	list-style: none;
	padding: 0;
}

.notice-list li {
	font-size: 15px;
	line-height: 2;
	color: #666;
	padding: 10px 0;
	padding-left: 25px;
	position: relative;
}

.notice-list li::before {
	content: "•";
	position: absolute;
	left: 10px;
	color: #409EFF;
	font-size: 20px;
}

.notice-list li strong {
	color: #333;
}

.contact-btn-box {
	margin-top: 25px;
}

.contact-btn {
	padding: 12px 40px;
	background: #409EFF;
	color: #fff;
	border: none;
	border-radius: 6px;
	font-size: 16px;
	cursor: pointer;
	transition: background 0.3s;
}

.contact-btn:hover {
	background: #337ecc;
}
</style>
